import { createBrowserHistory } from 'history';
// render react DOM

export default createBrowserHistory();
